/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP NotFound 화면 개발
 *
 ********************************************************************/
import React from "react";
import { useNavigate } from 'react-router-dom';
//recoil
import { useRecoilState, } from "recoil";
import { loadingBoxState } from "../../../recoil/menuState";
/**
 * @brief EHP NotFound 화면 컴포넌트
 * @param -
 * @returns react components
 */
//
function NotFound() {
    //recoil
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    const navigate = useNavigate();
    function onClickGoPage(url) {
        navigate(url);
        //
    }
    //setRecoilIsLoadingBox(false);
    return (React.createElement(React.Fragment, null,
        React.createElement("main", { className: "container filereports" },
            React.createElement("div", { className: "area__error error-404" },
                React.createElement("p", null, "\uC8FC\uC18C\uAC00 \uB9CC\uB8CC\uB418\uC5C8\uAC70\uB098, \uC694\uCCAD\uD558\uC2E0 \uD398\uC774\uC9C0\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.")))));
}
export default NotFound;
